import { gql } from '@apollo/client';

export const ADD_PERSON_TO_COHORTS = gql`
  mutation addPersonToCohorts($input: AddPersonToCohortsInput!) {
    person: addPersonToCohorts(input: $input) {
      id
    }
  }
`;
